import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Components
import { Preloader } from '@/components/ui/Preloader';
import { GeometricBackground } from '@/components/ui/GeometricBackground';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

// Sections
import { Hero } from '@/components/sections/Hero';
import { Portfolio } from '@/components/sections/Portfolio';
import { Expertise } from '@/components/sections/Expertise';
import { ContactForm } from '@/components/sections/ContactForm';
import { AiContact } from '@/components/sections/AiContact';

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-[#040d1e] via-[#07132c] to-[#0c0825]">
      {/* Preloader */}
      {isLoading && <Preloader onComplete={() => setIsLoading(false)} />}

      {/* Geometric Background */}
      <GeometricBackground />

      {/* Main Content */}
      <div className={`relative z-10 transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
        <Header />
        <main>
          <Hero />
          <Portfolio />
          <Expertise />
          <AiContact />
          <ContactForm />
        </main>
        <Footer />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
